window.BAO.MediaBreakpoints = class MediaBreakpoints {
  static get breakpoints () {
    return {
      xs: 450,
      sm: 768,
      md: 1023,
      lg: 1200,
      xlg: 1440,
      xxlg: 1600,
    }
  }

  static get isXxs () {
    return window.innerWidth > this.breakpoints.xs
  }

  static get isXs () {
    return window.innerWidth > this.breakpoints.xs
  }

  static get isSm () {
    return window.innerWidth >= this.breakpoints.sm
  }

  static get isMd () {
    return window.innerWidth > this.breakpoints.md
  }

  static get isLg () {
    return window.innerWidth > this.breakpoints.lg
  }

  static get isXlg () {
    return window.innerWidth > this.breakpoints.xlg
  }

  static get isXxlg () {
    return window.innerWidth > this.breakpoints.xxlg
  }

  static get isXxsViewport () {
    return window.innerWidth <= this.breakpoints.xs
  }

  static get isXsViewport () {
    return window.innerWidth < this.breakpoints.sm
  }

  static get isSmViewport () {
    return (
      this.breakpoints.sm <= window.innerWidth &&
      window.innerWidth <= this.breakpoints.md
    )
  }

  static get isMdViewport () {
    return (
      this.breakpoints.md < window.innerWidth &&
      window.innerWidth <= this.breakpoints.lg
    )
  }

  static get isLgViewport () {
    return (
      this.breakpoints.lg < window.innerWidth &&
      window.innerWidth <= this.breakpoints.xlg
    )
  }
}
